import styles from "../WorkspaceSidebar.module.scss";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../stores";
import { useCallback } from "react";
import locale from "../../../constants/locale";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import routes from "../../../constants/routes";
import { IoCalendarOutline } from "react-icons/io5";

const CalendarLink = observer(() => {
  const { selectedWorkspace } = useStore("workspaces");
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const routeTo = useCallback(
    (path: string) => {
      history.push(path.replace(":workspaceId", String(selectedWorkspace?.id)));
    },
    [history, selectedWorkspace]
  );

  const isActiveRoute = location.pathname.startsWith(
    routes.calendar.replace(":workspaceId", String(selectedWorkspace?.id))
  );

  if (!selectedWorkspace) {
    return null;
  }

  return (
    <button
      onClick={() => routeTo(routes.calendar)}
      style={{ height: "5rem" }}
      className="is-relative w-100 is-no-box-shadow button has-text-white is-flex is-flex-direction-column is-ghost"
    >
      <div
        style={{ display: "flex", padding: "0.4rem" }}
        className={"is-relative"}
      >
        {isActiveRoute && <div className={styles.active}></div>}
        <IoCalendarOutline
          style={{ zIndex: 50, padding: 2 }}
          color={isActiveRoute ? "#2A79EF" : undefined}
          size={26}
        />
      </div>
      <span className="subtitle is-7 has-text-white has-long-text">
        {t(locale.calendar)}
      </span>
    </button>
  );
});

export default CalendarLink;
